// @flow
import React from 'react';
import pdfIcon from 'assets/images/pdf-icon.png';
import pdfIconWhite from 'assets/images/pdfIconWhite.png';
import './styles.scss';
import classNames from 'classnames';

export const PdfButton = props => {
  const {
    text,
    mode,
    url,
    isMobile,
    className = '',
    disabled,
    onClick,
  } = props;

  const imageSrc = mode === 'light' ? pdfIcon : pdfIconWhite;
  // add conditional classes
  const buttonClass = classNames('pdf-button', className, {
    dark: mode === 'dark',
    light: mode === 'light',
    coral: mode === 'coral',
    transparent: mode === 'transparent',
  });

  return (
    <button type={'button'} className={'download-button'} onClick={onClick}>
      <a className={buttonClass} download="variations.pdf">
        <img src={imageSrc} alt="pdf icon" />
        {!isMobile && <span>{text}</span>}
      </a>
    </button>
  );
};
